import { Row, Col, Button, Badge } from "react-bootstrap";

import { FaEdit } from "react-icons/fa";

const ParticipantRow = ({id, name, programHistory = [], status}) => {
  return (
    <Row>
      <Col className="">
        <div className="program-card rounded shadow mb-4 p-3 ">
          <Row>
            <Col md={2} className="text-center">
              <img src="https://via.placeholder.com/100" alt="img" className="img-fluid rounded-circle" />
            </Col>
            <Col md={3} className="pt-3">
              <h5>ID {id}</h5>
              <p>{name}</p>
            </Col>
            <Col md={4} className="pt-3">
              programs: 
              {
                programHistory.map((ph) => (
                  <p className="mb-0">{ph.name}</p>
                ))
              }
            </Col>
            <Col md={1} className="pt-3">
              <Badge bg="primary">{status}</Badge>
            </Col>
            <Col md={2} className="text-end">
              <div className="m-2">
                <Button size="sm" variant="outline-primary">
                  <FaEdit size="1em" className="m-2" />
                  Edit
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default ParticipantRow;
